export const Info = ({ datasetId, password }) => {
  return (
    <div className="alert alert-info alert-dismissible fade show" role="alert">
      <h5>Login Information</h5>
      <table class="table">
      <thead>
      </thead>
      <tbody>
        <tr>
          <td className="table-active">Dataset ID</td>
          <td>{datasetId}</td>
        </tr>
        <tr>
          <td className="table-active">password</td>
          <td>{password}</td>
        </tr>
        </tbody>
      </table>
      <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
    </div>
  ) 
}
